/* lazy-img.js — below-the-hero images wait for the page (speed push 2026-09-25).
   Markup: <img data-lv-src="..." [data-lv-srcset="..."] loading="lazy"> and <video data-lv-poster="...">.
   Nothing is fetched before window load, so these images never compete with the hero (LCP). After load (+ idle) every
   source is restored at once and the browser's own loading="lazy" paces the rest — slider slides included, which an
   IntersectionObserver misses because their scroller clips them. Safe to include more than once. */
(function () {
  if (window.__lazyImg) return; window.__lazyImg = true;
  function show(el) {
    if (el.dataset.lvDone) return; el.dataset.lvDone = "1";
    if (el.tagName === "VIDEO") { if (el.dataset.lvPoster) el.poster = el.dataset.lvPoster; return; }
    if (el.dataset.lvSrcset) el.srcset = el.dataset.lvSrcset;
    if (el.dataset.lvSrc) el.src = el.dataset.lvSrc;
  }
  function start() { [].slice.call(document.querySelectorAll("img[data-lv-src], video[data-lv-poster]")).forEach(show); }
  function later() { (window.requestIdleCallback || function (f) { setTimeout(f, 150); })(start, { timeout: 1200 }); }
  if (document.readyState === "complete") later(); else window.addEventListener("load", later);
  // anything rendered later (quick-add, sliders built by JS) gets shown too
  if ("MutationObserver" in window) new MutationObserver(function () { if (document.readyState === "complete") start(); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
